import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { PaymentMethod } from '@domain/subscription/models/SubscriptionPlan';

export const usePaymentMethods = () => {
  const {
    data: paymentMethods,
    isLoading,
    error,
    refetch,
  } = useQuery<PaymentMethod[]>({
    queryKey: ['payment-methods'],
    queryFn: async () => {
      const response = await container.subscriptionRepository.getPaymentMethods();
      if (response.status === 'error') {
        throw new Error(response.error.message);
      }
      return response.data;
    },
    refetchOnWindowFocus: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    paymentMethods: paymentMethods || [],
    isLoading,
    error,
    refetch,
  };
};
